export default {
  zoneImportFile: {
    section: {
      partitionType: 'Select zone type',
      duplicate: 'Duplicate data handling',
      instructions: 'Import instructions',
      uploadFile: 'Upload file',
      validateResult: 'Validation result',
      importStats: 'Import statistics',
      errorDetails: 'Error details',
    },
    partitionType: {
      postCode: 'Post code',
      city: 'City',
      country: 'Country',
      byPostCode: 'By post code',
      byCity: 'By city',
      byCountry: 'By country',
    },
    postCodeMode: {
      normal: 'Normal post code',
      combination: 'Combined post code',
    },
    importType: {
      overwrite: 'Overwrite existing data',
      clearAndImport: 'Clear data and import again',
    },
    instruction: {
      downloadFirst: 'Download the import template first, fill in the data, and then upload it',
      fileSupport: 'Supported file formats: .xlsx, .xls. File size cannot exceed 10MB',
      autoValidate: 'The system validates the data format automatically. Invalid data will not be imported, and you can download the error report for details',
      duplicateWarning: 'When data is duplicated, newly imported data will overwrite existing data. Please proceed carefully',
    },
    upload: {
      dragText: 'Drag files here to upload',
      clickToChoose: 'Or click the button below to choose a file',
    },
    button: {
      downloadTemplate: 'Download template',
      chooseFile: 'Choose file',
      downloadErrorReport: 'Download error report',
      back: 'Back',
      startImport: 'Start import',
      importing: 'Importing...',
      exportErrorData: 'Export error data',
      reUpload: 'Import again',
      backToZoneList: 'Back to zone list',
    },
    stats: {
      total: 'Total: ',
      passed: 'Passed: ',
      failed: 'Failed: ',
      totalProcessed: 'Total processed',
      importSuccess: 'Imported',
      importFailed: 'Failed',
    },
    table: {
      rowNumber: 'No.',
      partitionType: 'Zone type',
      country: 'Country',
      state: 'State',
      city: 'City',
      startPostalCode: 'Start postal code',
      endPostalCode: 'End postal code',
      zone: 'Zone',
      errorReason: 'Error reason',
    },
    done: {
      title: 'Import completed',
      titleWithError: 'Import completed with failed data',
      textWithFailed: 'Processed {total} rows: {passed} succeeded, {failed} failed',
      textSuccess: 'Zone data has been imported. Processed {total} rows',
    },
    note: {
      validating: 'Validating the file automatically by zone type...',
      localError: 'File validation failed. Download the error report, fix the data, and upload again',
      passed: 'Validation passed. You can start importing',
      partial: 'The system has filtered invalid data automatically. Only validated data will be imported',
    },
    message: {
      invalidFileType: 'Only .xlsx and .xls files are supported',
      fileTooLarge: 'File size cannot exceed 10MB',
      oneFileOnly: 'Only one file can be uploaded. Please remove the existing file first',
      chooseFileFirst: 'Please choose a file first',
      parseFailed: 'File parsing failed. Please check the file and upload again',
      validateFirst: 'Please choose a file and complete validation first',
      fixLocalError: 'File validation failed. Please fix the data and upload again',
      emptyFile: 'The file is empty. Please upload again',
    },
    error: {
      duplicatePostalCodeRangeErrors: [
        'Import failed: Duplicate zone detail rows (identical data) found in the file. Please remove duplicate rows and import again',
        'Import failed: Duplicate postal code ranges found in the file. Please ensure each postal code range is unique and try again',
        'Alphanumeric postal codes do not support ranges. Start and end postal codes must be the same.',
        'Invalid postal code format',
      ],
    },
    validation: {
      headerField: 'Header',
      headerRequiredColumns: 'Please fill in the columns according to the template: {columns}',
      requiredSuffix: ' cannot be empty',
      zoneFormat: 'Zone can only contain English letters, numbers, or spaces, and cannot start or end with a space',
      countryFormat: 'Country must be a valid two-letter country code (such as CN or US)',
      stateFormat: 'State can only contain Chinese, English, or spaces',
      cityFormat: 'City can only contain Chinese, English, spaces, or commas',
      lettersNumbersSuffix: ' can only contain letters or numbers',
      combinationPostalCodeFormat: 'Postal Code can only contain integer numbers, commas, hyphens, or spaces, and cannot start or end with a space',
      postalCodeRange: 'End Postal Code cannot be smaller than Start Postal Code',
    },
    report: {
      importErrorFile: 'Import_Error_Data_',
      localErrorFile: 'Validation_Error_Report_',
      validationStatus: 'Validation status',
      validationPassed: 'Validation passed',
      separator: ', ',
      messageSeparator: '; ',
      fieldSeparator: ': ',
    },
  },
};
